import Vue from "vue";
import VueOnlineProp from "vue-online-prop";

Vue.use(VueOnlineProp);

export default VueOnlineProp;
